import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import GymMembers from "./GymMembers";
import GymBenefits from "./GymBenefits";

const GymManageTabs = ({ rowData, userInfoData, callFunction }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (index) => {
    setSelectedTab(index);
  };

  return (
    <div className="gym-manage-tabs-container mt30">
      <Tabs selectedIndex={selectedTab} onSelect={handleTabChange}>
        <TabList>
          <Tab>
            <div className="gym-manage-tabs-label">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-person-fill"
                viewBox="0 0 16 16"
              >
                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
              </svg>
              <span>Members</span>
            </div>
          </Tab>
          <Tab>
            <div className="gym-manage-tabs-label">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-person-fill"
                viewBox="0 0 16 16"
              >
                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
              </svg>
              <span>Trainer</span>
            </div>
          </Tab>
          <Tab>
            <div className="gym-manage-tabs-label">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-person-fill"
                viewBox="0 0 16 16"
              >
                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
              </svg>
              <span>Benefit</span>
            </div>
          </Tab>
        </TabList>

        <TabPanel>
          <GymMembers
            userInfoData={userInfoData}
            rowData={rowData}
            selectedTab={selectedTab}
          />
        </TabPanel>
        <TabPanel>
          <GymMembers
            userInfoData={userInfoData}
            rowData={rowData}
            selectedTab={selectedTab}
          />
        </TabPanel>
        <TabPanel>
          <GymBenefits userInfoData={userInfoData} rowData={rowData} />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default GymManageTabs;
